module.exports = __webpack_public_path__ + "static/media/17.9065fc16.jpg";